"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _createSvg = require("../createSvg");
var _interfaces = require("../interfaces");
var _SVGIconWithSizes;
var _default = (0, _createSvg.createSvg)('IconPaste', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M8 1C7.06806 1 6.28499 1.63742 6.06299 2.50006H3.5C2.94772 2.50006 2.5 2.94778 2.5 3.50006V14.0001C2.5 14.5523 2.94772 15.0001 3.5 15.0001H12.5C13.0523 15.0001 13.5 14.5523 13.5 14.0001V3.50006C13.5 2.94778 13.0523 2.50006 12.5 2.50006H9.93701C9.71501 1.63742 8.93194 1 8 1ZM4.5 4.50006V13.0001H11.5V4.50006H11V5.00006C11 5.55235 10.5523 6.00006 10 6.00006H6C5.44772 6.00006 5 5.55235 5 5.00006V4.50006H4.5Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M10 1C8.79054 1 7.78168 1.85885 7.55002 2.99994H4C3.44772 2.99994 3 3.44765 3 3.99994V17.9999C3 18.5522 3.44772 18.9999 4 18.9999H16C16.5523 18.9999 17 18.5522 17 17.9999V3.99994C17 3.44765 16.5523 2.99994 16 2.99994H12.45C12.2183 1.85885 11.2095 1 10 1ZM5 4.99994V16.9999H15V4.99994H14C14 5.55222 13.5523 6 13 6H7C6.44772 6 6 5.55228 6 5L5 4.99994Z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M12 1C10.6938 1 9.58254 1.83481 9.17071 3H5C4.44772 3 4 3.44772 4 4V22C4 22.5523 4.44772 23 5 23H19C19.5523 23 20 22.5523 20 22V4C20 3.44772 19.5523 3 19 3H14.8293C14.4175 1.83481 13.3062 1 12 1ZM8 5V6C8 6.55228 8.44772 7 9 7H15C15.5523 7 16 6.55228 16 6V5H18V21H6V5H8Z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M16 1C14.1362 1 12.5701 2.27477 12.126 4H6.5C5.67157 4 5 4.67157 5 5.5V29.5C5 30.3284 5.67157 31 6.5 31H25.5C26.3284 31 27 30.3284 27 29.5V5.5C27 4.67157 26.3284 4 25.5 4H19.874C19.4299 2.27477 17.8638 1 16 1ZM8 7V28H24V7H21V8C21 8.82843 20.3284 9.5 19.5 9.5H12.5C11.6716 9.5 11 8.82843 11 8V7H8Z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));
exports.default = _default;